module.exports = __webpack_public_path__ + "img/uv_5.380134ff.png";